import { useContext } from 'react';
import type { AppParamsContextProps } from './AppParamsContext';
import { AppParamsContext } from './AppParamsContext';

export const useAppParamsContext = (): AppParamsContextProps => {
    const context = useContext(AppParamsContext);
    if (!context) {
        throw new Error(
            'useAppParams must be used within an AppParamsProvider',
        );
    }
    return context;
};
